import React, { useState } from 'react';
import { useAuth, isUserActive } from '../../../contexts/AuthContext';
import { ChangePasswordModal } from '../../../components/ChangePasswordModal';
import styles from './AdminProfile.module.css';

const AdminProfile: React.FC = () => {
  const { user, logout } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const initial = (user?.full_name || 'A').charAt(0).toUpperCase();
  const isActive = isUserActive(user);
  // Prefer the admin-managed employee_id (migration 027); show 'N/A' when unset.
  const adminId = user?.employee_id || 'N/A';

  return (
    <div className={styles.container}>
      <div className={styles.heroCard}>
        <div className={styles.avatar}>{initial}</div>
        <div className={styles.heroBody}>
          <h2 className={styles.heroName}>{user?.full_name || 'N/A'}</h2>
          <span className={styles.heroRole}>{user?.role || 'N/A'}</span>
          <span
            className={`${styles.heroStatus} ${!isActive ? styles.heroStatusInactive : ''}`}
          >
            {isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
      </div>

      <div className={styles.infoCard}>
        <h3 className={styles.cardTitle}>Account Information</h3>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Full Name</span>
          <span className={styles.fieldValue}>{user?.full_name || 'N/A'}</span>
        </div>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Email</span>
          <span className={styles.fieldValue}>{user?.email || 'N/A'}</span>
        </div>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Role</span>
          <span className={styles.fieldValue}>{user?.role || 'N/A'}</span>
        </div>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Employee ID</span>
          <span className={styles.fieldValue}>{adminId}</span>
        </div>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Phone</span>
          <span className={styles.fieldValue}>{user?.phone || 'N/A'}</span>
        </div>
        <div className={styles.fieldRow}>
          <span className={styles.fieldLabel}>Department</span>
          <span className={styles.fieldValue}>{user?.department || 'N/A'}</span>
        </div>
      </div>

      <button
        type="button"
        className={styles.securityButton}
        onClick={() => setShowPasswordModal(true)}
      >
        Change Password
      </button>

      <button type="button" className={styles.logoutButton} onClick={logout}>
        <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
        </svg>
        Logout
      </button>

      <p className={styles.version}>VIN pulse OS v2.1.0</p>

      <ChangePasswordModal
        open={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />
    </div>
  );
};

export const AdminProfilePage: React.FC = () => {
  return <AdminProfile />;
};

export { AdminProfile };
export default AdminProfile;
